<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden auth-screen">

  <!-- Background -->
  <div class="auth-hero-bg position-absolute top-0 start-0 w-100 h-100"></div>

  <!-- CONTENT LAYER -->
  <div class="container position-relative z-1 min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center align-items-center w-100">

      <!-- =========================
           PASSWORD RESET COMPLETE
      =========================== -->
      <div
        class="glass-card glass-card-neon p-4 p-md-5 rounded-4 shadow-sm
               col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto"
      >

        <!-- Logo -->
        <div class="text-center mb-3">
          <router-link
            to="/"
            class="auth-logo mb-2 text-decoration-none d-inline-block"
            aria-label="Bolide Home"
          ></router-link>
        </div>

        <!-- Heading -->
        <h3 class="mb-1 text-center text-white">Password Reset Complete</h3>
        <p class="text-center text-white-50 mb-4 text-sm">
          Your password has been successfully reset.
          You can now log in using your new credentials.
        </p>

        <SnackbarMessage :success-message="success_message" @dismiss-success="success_message = ''" />

        <!-- Back To Login -->
        <div class="text-center">
          <router-link
            to="/login"
            class="btn btn-primary w-100 rounded-3 fw-light text-xs mb-0 text-decoration-none d-block"
          >
            Go to Login
          </router-link>
        </div>

      </div>

    </div>
  </div>
</div>
